import { LocationStrategy } from "@angular/common";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/services/base.service";
import { IMatrizRiscoControle } from "../model/matriz-risco-controle.model";
import { IBaseModel } from "src/app/models/base.model";

@Injectable({
    providedIn: 'root',
})
export class MatrizRiscoControleService extends BaseService {


    constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
        super(httpClient, locationStrategy);
    }

    public obter(pesquisar: string, idPlanejamento: any): Promise<IBaseModel<IMatrizRiscoControle[]>> {
        let params = new HttpParams();
        params = params.append('pesquisa', pesquisar);
        params = params.append('idPlanejamento', idPlanejamento);

        return this.httpClient
				.get<IBaseModel<IMatrizRiscoControle[]>>(`${this.apiBaseUrl}/planejamento/obterListMatrizRiscoControle`, { params })
            .toPromise();
    }

    public obterPorPlanejamento(idPlanejamento: any, idUnidade: any , idMatrizPlanejamento: any): Promise<IBaseModel<IMatrizRiscoControle[]>> {
        let params = new HttpParams();
        params = params.append('idPlanejamento', idPlanejamento);
        params = params.append('idUnidade', idUnidade);
        params = params.append('idMatrizPlanejamento', idMatrizPlanejamento);

        return this.httpClient
            .get<IBaseModel<IMatrizRiscoControle[]>>(`${this.apiBaseUrl}/planejamento/obterMatrizRiscoControle`, { params })
            .toPromise();
    }

    public async inserir(model: IMatrizRiscoControle): Promise<IBaseModel<IMatrizRiscoControle>> {
        return this.httpClient
            .post<IBaseModel<IMatrizRiscoControle>>(`${this.apiBaseUrl}/planejamento/matrizRiscoControle`, model)
            .toPromise();
    }

    public async excluir(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
            .delete<IBaseModel<void>>(`${this.apiBaseUrl}/planejamento/matrizRiscoControle/${id}/excluir`, { })
            .toPromise();
    }
}
